import { useState, useEffect } from 'react';

import { useStores } from 'src/hooks/use-stores';
import useDebounce from 'shared/hooks/use-debounce';
import { isValidHttpUrl as isValidUrl } from 'shared/helpers/utils';
import { generateEmbedScript } from '../embed-homepage-sections/embed-homepage-sections.utils';

export function useEmbedCollectionCarousel({ dispensary, collections }) {
  const { UI } = useStores();
  const [currentCollection, setCurrentCollection] = useState(collections[0]);
  const [hideTitle, setHideTitle] = useState(false);
  const [hideViewAllLink, setHideViewAllLink] = useState(false);
  const [carouselTheme, setCarouselTheme] = useState({});
  const [menuUrl, setMenuUrl] = useState(dispensary.menuUrl);
  const [menuUrlInputError, setMenuUrlInputError] = useState(false);
  const debouncedMenuUrl = useDebounce(menuUrl, 2000);

  const handleMenuUrlChange = (e) => {
    setMenuUrl(e.target.value);
    if (isValidUrl(e.target.value)) {
      setMenuUrlInputError(false);
    } else {
      setMenuUrlInputError(true);
    }
  };

  const handleCollectionSelect = (e) => {
    setCurrentCollection(collections.find((collection) => collection.value === e.target.value));
  };

  useEffect(() => {
    if (isValidUrl(debouncedMenuUrl) && debouncedMenuUrl !== dispensary.menuUrl) {
      setMenuUrlInputError(false);
      UI.updateDispensaryProperty('menuUrl', debouncedMenuUrl);
      UI.saveDispensaryInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedMenuUrl]);

  const script = currentCollection
    ? generateEmbedScript({
        menuUrl,
        dispensaryId: dispensary.id,
        menuSectionId: currentCollection.id,
        hideViewAllLink,
        hideTitle,
        carouselTheme,
      })
    : '';

  return {
    carouselTheme,
    currentCollection,
    handleCollectionSelect,
    handleMenuUrlChange,
    hideTitle,
    hideViewAllLink,
    menuUrl,
    menuUrlInputError,
    script,
    setCarouselTheme,
    setHideTitle,
    setHideViewAllLink,
  };
}
